import DseDetails from './dseDetails';

export default DseDetails;
